"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const ArrowLeftRightHalfSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16.4278 10.6648L13.4758 9.28823C13.2256 9.17153 13.1173 8.87404 13.234 8.62377C13.3507 8.3735 13.6482 8.26522 13.8985 8.38193L18.43 10.495C18.5221 10.538 18.595 10.6054 18.6445 10.686C18.8502 10.7479 19 10.9389 19 11.1648C19 11.4409 18.7761 11.6648 18.5 11.6648H1.5C1.22386 11.6648 1 11.4409 1 11.1648C1 10.8886 1.22386 10.6648 1.5 10.6648H16.4278Z" fill="currentColor" />
  </svg>
)

const ArrowLeftRightHalfIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowLeftRightHalfSvg} {...props} />
);

export default ArrowLeftRightHalfIcon